import { useState } from 'react';

import TextOverflowTooltip from '@atom/components/common/tooltip/TextOverflowTooltip';
import { DatePicker, DateTimePicker } from '@atom/mui';
import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';
import { DataType } from '@atom/types/dataType';
import { WorkOrderField } from '@atom/types/work';
import { PREVIEW_FIELD_WIDTH } from '@atom/utilities/taskUtilities';

interface Props {
  field: WorkOrderField;
  onChange: (fieldId: string, value: any) => void;
  isDisabled?: boolean;
}

const WorkOrderDatePicker = ({ field, onChange, isDisabled }: Props) => {
  const [value, setValue] = useState<Date>(
    field.value ? new Date(field.value) : null,
  );

  const handleChange = (date?: Date) => {
    setValue(date);
    // date was removed entirely
    if (!date) {
      onChange(field.id, '');
    } else if (!Number.isNaN(date.valueOf())) {
      onChange(field.id, date.valueOf());
    }
  };

  const props = {
    value,
    onChange: handleChange,
    disabled: isDisabled,
    style: { width: PREVIEW_FIELD_WIDTH },
  };

  const content =
    field.dataType === DataType.DATE ? (
      <DatePicker {...props} />
    ) : (
      <DateTimePicker {...props} />
    );

  return (
    <div>
      <TextOverflowTooltip
        width={PREVIEW_FIELD_WIDTH}
        text={field.title}
        color={colors.neutral.dim}
        fontSize={fonts.sm}
      />
      {content}
    </div>
  );
};

export default WorkOrderDatePicker;
